import { API_URL } from "../config/config";
import { getRequest, postRequest } from "../utils/axiosUtils";

export const fetchToolsList = async (setToolsList, setLoadingTools) => {
  if (setLoadingTools) setLoadingTools(true);
  try {
    const response = await getRequest({
      url: `${API_URL}/tools`,
    });
    const tools = response?.data?.tools;
    if (!response?.data?.success || !Array.isArray(tools)) {
      const error = new Error(response?.data?.message || "Tools not found");
      error.fieldErrors = response?.data?.errors || {};
      throw error;
    }
    const mappedTools = tools.map(item => ({
      label: item.name || item.toolName,
      value: item._id || item.toolId,   
      image: item.image || item.logo || "",
    }));
    if (setToolsList) setToolsList(mappedTools);
    return mappedTools;
  } catch (err) {
    if (setToolsList) setToolsList([]);
    const responseData = err?.response?.data;
    if (responseData) {
      const customError = new Error(responseData.message || "Failed to fetch tools");
      customError.fieldErrors = responseData.errors || {};
      throw customError;
    }
    throw new Error(err.message || "Unknown error occurred while fetching tools");
  } finally {
    if (setLoadingTools) setLoadingTools(false);
  }
};

export const addTools = async ({ name, image }, setLoadingAddTool) => {
  if (setLoadingAddTool) setLoadingAddTool(true);
  try {
    const response = await postRequest({
      url: `${API_URL}/tools`,
      data: { name, image },
    });
    const tool = response?.data?.tool;
    if (!response?.data?.success || !tool) {
      const error = new Error(response?.data?.message || "Failed to add tool");
      error.fieldErrors = response?.data?.errors || {};
      throw error;
    }
    return {
      label: tool.name || tool.toolName,
      value: tool._id || tool.toolId,
      image: tool.image || tool.logo || "",
    };
  } catch (err) {
    const responseData = err?.response?.data;
    if (responseData) {
      const customError = new Error(responseData.message || "Failed to add tool");
      customError.fieldErrors = responseData.errors || {};
      throw customError;
    }
    throw new Error(err.message || "Unknown error occurred while adding tool");
  } finally {
    if (setLoadingAddTool) setLoadingAddTool(false);
  }
};